
import VueRecaptcha from "vue-recaptcha";
import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import vueFilePond, { setOptions } from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize
);

interface ticketData {
  rut: string;
  name: string;
  father_last_name: string;
  mother_last_name: string;
  document_type: string;
  document_id: string;
  phone: number | null;
  email: string;
  message: string;
}
@Component({
  components: {
    FilePond,
    VueRecaptcha
  }
})
export default class SendTreeTicketForm extends Mixins(FormValidator) {
  protected formData: ticketData = {
    rut: "",
    name: "",
    father_last_name: "",
    mother_last_name: "",
    document_type: "1",
    document_id: "",
    phone: null,
    email: "",
    message: ""
  };

  protected captcha_key = "";
  private beforeMount() {
    this.captcha_key = process.env.VUE_APP_KEY_CAPTCHA as string;
  }

  private onVerify(response: any) {
    this.sendTicketAttemp();
  }

  private onExpired() {
    this.$q.notify({
      color: "negative",
      message: "Por favor, recargue la página.",
      icon: "report_problem",
      position: "top",
      timeout: 2500
    });
  }

  private onError() {
    this.$q.notify({
      color: "negative",
      message: "Ha ocurrido un error, intente más tarde.",
      icon: "report_problem",
      position: "top",
      timeout: 2500
    });
  }

  private chilean: boolean = true;

  private areAllFilesOK(): boolean {
    let files = (this.$refs.pond as any).getFiles();
    for (let i = 0; i < files.length; i++) {
      if (files[i].status != 5) {
        return false;
      }
    }
    return true;
  }

  private triggerFilepond() {
    (document.getElementsByClassName(
      "filepond--browser"
    )[0] as HTMLInputElement).click();
  }

  private typeDetection(file: any, type: any) {
    let checkExtensions = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
    let isAllowed = new Promise((resolve, reject) => {
      let extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if (checkExtensions.indexOf(extension) > -1) {
        let officeType = "";
        switch (extension) {
          case "doc":
          case "docx":
            officeType = "application/doc";
            break;
          case "xls":
          case "xlsx":
            officeType = "application/xls";
            break;
          case "ppt":
          case "pptx":
            officeType = "application/ppt";
            break;
          default:
            officeType = "";
            break;
        }
        if (officeType === "") {
          reject();
        } else {
          resolve(officeType);
        }
      } else {
        resolve(type);
      }
    });
    return isAllowed;
  }

  private options_document: object[] = [
    { label: "DNI", value: "0" },
    { label: "RUT", value: "1" },
    { label: "Pasaporte", value: "2" }
  ];

  private async sendTicketAttemp() {
    //this.disable_button = true;
    if (!this.areAllFilesOK()) {
      this.$q.notify({
        message: this.$t("notification.problem_with_files") as string,
        color: "accent",
        position: "top",
        timeout: 7500
      });
      //this.disable_button = false;
      return;
    }

    /*let captcha = (window as any).grecaptcha.getResponse();
    if (captcha == "") {
      this.$q.notify({
        message: this.$t("notification.check_captcha") as string,
        color: "accent",
        position: "top",
        timeout: 7500
      });
      //this.disable_button = false;
      return;
    }*/

    await this.$recaptchaLoaded();
    //6LdXOpsnAAAAAHW2T2TIAAQMOu1KfcXELyRLciPw
    //let captcha = (window as any).grecaptcha.getResponse();
    let captcha = ""
    try {
      captcha = await this.$recaptcha('CREATE_TICKET_TREE')
    } catch(_) {
      this.$q.notify({
        message: this.$t("notification.check_captcha") as string,
        color: "accent",
        position: "top",
        timeout: 7500
      });
      return;      
    }

    if (captcha == "") {
      this.$q.notify({
        message: this.$t("notification.check_captcha") as string,
        color: "accent",
        position: "top",
        timeout: 7500
      });
      return;
    }

    // ordenar input de archivos filepond)
    let adjuntos_input = document.getElementsByName("Files");
    // backend no soporta vacio, debe ser null
    let adjuntos_empty = true;
    let adjuntos: any = [];
    for (let i = 0; i < adjuntos_input.length; i++) {
      adjuntos[i] = (adjuntos_input[i] as HTMLInputElement).value;
    }
    for (let j = 0; j < adjuntos.length; j++) {
      if (adjuntos[j] !== "") {
        adjuntos_empty = false;
      }
    }
    if (adjuntos_empty) {
      adjuntos = null;
    }

    // enviar post al backend.
    this.$axios
      .post(
        "tickets/solicitud/arbolado",
        {
          rut: this.$store.state.logged
            ? this.$store.state.user.rut
            : this.$store.state.ticket.guest_id,
          tipo_documento: this.$store.state.logged
            ? this.$store.state.user.document_type
            : this.$store.state.ticket.guest_document_type,
          id_arbol: this.$route.query.id_arbol,
          origen: 4,
          tipo: Number(this.$store.state.ticket.motive),
          mensaje: this.formData.message,
          dispositivo: navigator.userAgent,
          adjunto: adjuntos
        },
        {
          headers: {
            Authorization: this.$store.state.user.auth_token
              ? this.$store.state.user.auth_token
              : null,
            Captcha: captcha
          }
        }
      )
      .then(response => {
        let ticket = {
          id: response.data.response.id,
          guest_id: response.data.response.guest_id,
          guest_name: response.data.response.guest_name,
          guest_lastname: response.data.response.guest_lastname,
          guest_mother_lastname: response.data.response.guest_mother_lastname,
          message: response.data.response.message,
          date: response.data.response.date,
          service_name: "Permisos de Circulación",
          step: 4,
          adjuntos: response.data.response.adjuntos
            ? response.data.response.adjuntos
            : null
        };
        this.$store.dispatch("submitFinishedGuestRequest", ticket);
      })
      .catch(error => {
        return error;
      });
  }

  private filepondServer = {
    url: process.env.VUE_APP_API_PATH + "/temporal_archivos/",
    process: {
      url: "upload",
      method: "PUT",
      withCredentials: false,
      onload: (response: string) => {
        let json_response = JSON.parse(response);
        return json_response.response.nombre;
      },
      onerror: (response: any) => response.data,
      ondata: (formData: any) => {
        return formData;
      }
    },
    revert: "delete",
    restore: null,
    load: null,
    fetch: null
  };

  private mounted() {}
}
